.createChatDialogBody {
  height: 100vh;
}